export default {
  '请先勾选需要转码的任务': {
    zh: '请先勾选需要转码的任务',
    en: 'Please select the tasks to transcode first',
    ar: 'يرجى أولاً تحديد المهام التي تريد تحويل ترميزها',
    fa: 'لطفاً ابتدا وظایفی را که باید تبدیل کد شوند انتخاب کنید',
    pt: 'Selecione primeiro as tarefas que deseja transcodificar'
  },
  '确定转码已选任务吗?': {
    zh: '确定转码已选任务吗?',
    en: 'Are you sure you want to transcode the selected tasks?',
    ar: 'هل أنت متأكد من تحويل ترميز المهام المحددة؟',
    fa: 'آیا از تبدیل کد وظایف انتخاب‌شده مطمئن هستید؟',
    pt: 'Tem certeza de que deseja transcodificar as tarefas selecionadas?'
  },
  '请先勾选需要开启的任务': {
    zh: '请先勾选需要开启的任务',
    en: 'Please select the tasks to enable first',
    ar: 'يرجى أولاً تحديد المهام التي تريد تفعيلها',
    fa: 'لطفاً ابتدا وظایفی را که باید فعال شوند انتخاب کنید',
    pt: 'Selecione primeiro as tarefas que deseja ativar'
  },
  '请先勾选需要暂停的任务': {
    zh: '请先勾选需要暂停的任务',
    en: 'Please select the tasks to pause first',
    ar: 'يرجى أولاً تحديد المهام التي تريد إيقافها مؤقتًا',
    fa: 'لطفاً ابتدا وظایفی را که باید متوقف شوند انتخاب کنید',
    pt: 'Selecione primeiro as tarefas que deseja pausar'
  },
  '请选择状态一致的任务': {
    zh: '请选择状态一致的任务',
    en: 'Please select tasks with the same status',
    ar: 'يرجى تحديد المهام التي لها الحالة نفسها',
    fa: 'لطفاً وظایفی با وضعیت یکسان انتخاب کنید',
    pt: 'Selecione tarefas com o mesmo status'
  },
  '所选任务已开启': {
    zh: '所选任务已开启',
    en: 'The selected tasks are already enabled',
    ar: 'المهام المحددة مفعلة بالفعل',
    fa: 'وظایف انتخاب‌شده از قبل فعال هستند',
    pt: 'As tarefas selecionadas já estão ativadas'
  },
  '所选任务已暂停': {
    zh: '所选任务已暂停',
    en: 'The selected tasks are already paused',
    ar: 'المهام المحددة متوقفة مؤقتًا بالفعل',
    fa: 'وظایف انتخاب‌شده از قبل متوقف شده‌اند',
    pt: 'As tarefas selecionadas já estão pausadas'
  },
  '确定开启已选任务吗?': {
    zh: '确定开启已选任务吗?',
    en: 'Are you sure you want to enable the selected tasks?',
    ar: 'هل أنت متأكد من تفعيل المهام المحددة؟',
    fa: 'آیا از فعال کردن وظایف انتخاب‌شده مطمئن هستید؟',
    pt: 'Tem certeza de que deseja ativar as tarefas selecionadas?'
  },
  '确定暂停已选任务吗?': {
    zh: '确定暂停已选任务吗?',
    en: 'Are you sure you want to pause the selected tasks?',
    ar: 'هل أنت متأكد من إيقاف المهام المحددة مؤقتًا؟',
    fa: 'آیا از متوقف کردن وظایف انتخاب‌شده مطمئن هستید؟',
    pt: 'Tem certeza de que deseja pausar as tarefas selecionadas?'
  },
  '操作成功': {
    zh: '操作成功',
    en: 'Operation successful',
    ar: 'تمت العملية بنجاح',
    fa: 'عملیات با موفقیت انجام شد',
    pt: 'Operação realizada com sucesso'
  },
     '柱状图': {
    zh: '柱状图',
    en: 'Bar Chart',
    ar: 'مخطط شريطي',
    fa: 'نمودار میله‌ای',
    pt: 'Gráfico de barras'
  },   
  '折线图': {
    zh: '折线图',
    en: 'Line Chart',
    ar: 'مخطط خطي',
    fa: 'نمودار خطی',
    pt: 'Gráfico de linhas'
  },  
  '节目识别码': {
    zh: '节目识别码',
    en: 'Callsign',
    ar: 'رمز الاتصال',
    fa: 'کد شناسایی برنامه',
    pt: 'Código de identificação do programa'
  },  
  '过去3天使用频次': {
    zh: '过去3天使用频次',
    en: 'Usage Frequency (Past 3 Days)',
    ar: 'تكرار الاستخدام (آخر 3 أيام)',
    fa: 'فرکانس استفاده (3 روز گذشته)',
    pt: 'Frequência de uso (últimos 3 dias)'
  },  
  '平均观看时长(min)': {
    zh: '平均观看时长(min)',
    en: 'Average Viewing Duration (min)',
    ar: 'متوسط مدة المشاهدة (دقيقة)',
    fa: 'میانگین مدت زمان تماشا (دقیقه)',
    pt: 'Duração média de visualização (min)'
  },  
  '平均观看时长': {
    zh: '平均观看时长',
    en: 'Average Viewing Duration',
    ar: 'متوسط مدة المشاهدة',
    fa: 'میانگین مدت زمان تماشا',
    pt: 'Duração média de visualização'
  },  
  '频道名称、节目识别码': {
    zh: '频道名称、节目识别码',
    en: 'Channel Name, Callsign',
    ar: 'اسم القناة، رمز الاتصال',
    fa: 'نام کانال، کد شناسایی برنامه',
    pt: 'Nome do canal, código de identificação do programa'
  },  
  '频道实时观看人数': {
    zh: '频道实时观看人数',
    en: 'Real-time Channel Viewers',
    ar: 'عدد المشاهدين للقناة في الوقت الفعلي',
    fa: 'تعداد بینندگان کانال در زمان واقعی',
    pt: 'Visualizadores do canal em tempo real'
  },  
  '实时观看人数': {
    zh: '实时观看人数',
    en: 'Real-time Viewers',
    ar: 'عدد المشاهدين في الوقت الفعلي',
    fa: 'تعداد بینندگان در زمان واقعی',
    pt: 'Visualizadores em tempo real'
  },  
  '每5分钟统计：每500用户中经历≥200ms卡顿的用户数': {
    zh: '每5分钟统计：每500用户中经历≥200ms卡顿的用户数',
    en: 'Statistics every 5 minutes: Number of users experiencing ≥200ms stuttering per 500 users',
    ar: 'إحصائيات كل 5 دقائق: عدد المستخدمين الذين يعانون من توقف ≥200 مللي ثانية لكل 500 مستخدم',
    fa: 'آمار هر 5 دقیقه: تعداد کاربرانی که لگ ≥200 میلی‌ثانیه را تجربه می‌کنند به ازای هر 500 کاربر',
    pt: 'Estatísticas a cada 5 minutos: Número de usuários que experimentam travamentos ≥200ms por 500 usuários'
  },  
  '人数': {
    zh: '人数',
    en: 'Number of People',
    ar: 'عدد الأشخاص',
    fa: 'تعداد افراد',
    pt: 'Número de pessoas'
  },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
//   '折线图': {
//     zh: '折线图',
//     en: '',
//     ar: '',
//     fa: '',
//     pt: ''
//   },  
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },   
  // '增加': {
  //   zh: '增加',
  //   en: '',
  //   ar: '',
  //   fa: '',
  //   pt: ''
  // },  
}